import { render, staticRenderFns } from "./ValueGroup.vue?vue&type=template&id=1c927564&scoped=true&"
import script from "./ValueGroup.vue?vue&type=script&lang=js&"
export * from "./ValueGroup.vue?vue&type=script&lang=js&"
import style0 from "./ValueGroup.vue?vue&type=style&index=0&id=1c927564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c927564",
  null
  
)

export default component.exports